import React, { useEffect } from 'react';
import { CarrierDataForm } from '../../../../app/models/Carrier';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import useRut from '../../../../hooks/useRut';
import { User } from '../../../../app/models/User';
import { Society } from '../../../../app/models/Society';
import { Provider } from '../../../../app/models/Provider';
import { Brand } from '../../../../app/models/Brand';
import { VehicleModel } from '../../../../app/models/VehicleModel';
import { Truck, TruckDataForm } from '../../../../app/models/Truck';
import { WorkOrderDataForm } from '../../../../app/models/WorkOrder';

interface GeneralWorkOrderProps {
    workOrderForm: WorkOrderDataForm;
    setWorkOrderForm: (truck: WorkOrderDataForm) => void;
    societies: Society[];
    trucks: Truck[];
    errorFields?: any;
}

const WorkOrderForm = ({
    workOrderForm,
    setWorkOrderForm,
    societies,
    trucks,
    errorFields
}: GeneralWorkOrderProps) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const { formatRut } = useRut();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = event.target;

        setWorkOrderForm({ ...workOrderForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };

        setWorkOrderForm({ ...workOrderForm, ...obj });
    };

    if (!workOrderForm) return null;

    return (
        <>
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Sociedades</label>
                    <SelectTwo
                        name="society_id"
                        id="society_id"
                        inputValue={workOrderForm.society_id}
                        options={SelectTwoMapperOptions(societies, 'id', ['name'])}
                        hasError={fieldHasError('society_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('society_id', value.value)}
                        placeholder={'Seleccione Sociedad'}
                        onFocus={() => onFocusRemove('society_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('society_id')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Tractos</label>
                    <SelectTwo
                        name="truck_id"
                        id="truck_id"
                        inputValue={workOrderForm.truck_id}
                        options={SelectTwoMapperOptions(trucks, 'id', ['name'])}
                        hasError={fieldHasError('truck_id') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('truck_id', value.value)}
                        placeholder={'Seleccione tracto'}
                        onFocus={() => onFocusRemove('truck_id')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('truck_id')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Periodo</label>
                    <input
                        name={'period'}
                        id={`period`}
                        type="month"
                        value={workOrderForm.period}
                        className={`form-control ${fieldHasError(`period`)}`}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove(`period`)}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage(`period`)}
                    </div>
                </div>
            </div>
        </>
    );
};

export default WorkOrderForm;
